
    (function(){
      var rmm=document.getElementById('ipResearchModal');
      if(!rmm || rmm.dataset.iprWired) return;
      rmm.dataset.iprWired='1';
      var trigger=null, animated=false;

      function animate(){
        if(animated) return; animated=true;
        var root=rmm.querySelector('.rm-scroll');
        if(!('IntersectionObserver' in window)){
          rmm.querySelectorAll('.rm-anim').forEach(function(el){el.classList.add('in')});
          return;
        }
        [['.rm-section',0],['.rm-thesis__step',60],['.rm-method',55],['.rm-ladder__step',55],['.rm-product',90],['.rm-sources li',26]]
          .forEach(function(g){
            rmm.querySelectorAll(g[0]).forEach(function(el,n){
              el.classList.add('rm-anim');
              el.style.setProperty('--d',(n*g[1])+'ms');
            });
          });
        var io=new IntersectionObserver(function(es){
          es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target) } });
        },{root:root,threshold:.08,rootMargin:'0px 0px -6% 0px'});
        rmm.querySelectorAll('.rm-anim,.rm-timeline,.rm-era').forEach(function(el){io.observe(el)});
        rmm.querySelectorAll('.rm-era').forEach(function(el,n){el.style.setProperty('--d',(n*90)+'ms')});

        var links=[].slice.call(rmm.querySelectorAll('.rm-nav a'));
        var spy=new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(!e.isIntersecting) return;
            links.forEach(function(a){a.classList.toggle('on',a.getAttribute('href')==='#'+e.target.id)});
          });
        },{root:root,threshold:.02,rootMargin:'-12% 0px -70% 0px'});
        rmm.querySelectorAll('.rm-section[id]').forEach(function(s){spy.observe(s)});
      }

      document.querySelectorAll('[data-research-open]').forEach(function(b){
        b.addEventListener('click',function(){ trigger=b; rmm.showModal(); animate(); });
      });
      rmm.querySelectorAll('[data-research-close]').forEach(function(c){
        c.addEventListener('click',function(){ rmm.close(); });
      });
      rmm.addEventListener('click',function(e){ if(e.target===rmm) rmm.close(); });
      rmm.addEventListener('close',function(){ if(trigger){ trigger.focus(); trigger=null } });
    })();
    
;

        /* Composition pills beside the bottle: once a label wraps to 2-3 lines, CSS keeps its box at the
           max-width, so the pill would be wider than its text. Shrink each wrapped pill to its widest line.
           Progressive enhancement - without it the pills still stay off the bottle, just a little wider. */
        (function () {
            var pills = [].slice.call(document.querySelectorAll('.pill.pill-static'));
            if (!pills.length || !document.createRange) return;
            function textOf(p) {
                for (var n = p.lastChild; n; n = n.previousSibling) if (n.nodeType === 3 && n.nodeValue.trim()) return n;
                return null;
            }
            function fit() {
                pills.forEach(function (p) {
                    p.style.width = '';
                    var t = textOf(p); if (!t) return;
                    var r = document.createRange(); r.selectNodeContents(t);
                    var lines = r.getClientRects(); if (lines.length < 2) return;   /* one line is already tight */
                    var scale = (p.getBoundingClientRect().width / p.offsetWidth) || 1;  /* entrance scale */
                    var w = 0; for (var i = 0; i < lines.length; i++) w = Math.max(w, lines[i].width);
                    var cs = getComputedStyle(p), dot = p.querySelector('.pill-dot');
                    var extra = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + parseFloat(cs.borderLeftWidth) +
                                parseFloat(cs.borderRightWidth) + (dot ? dot.offsetWidth + (parseFloat(cs.columnGap) || 0) : 0);
                    p.style.width = Math.ceil(w / scale + extra + 1) + 'px';
                });
            }
            var timer;
            fit();
            window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(fit, 120); }, { passive: true });
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
        })();

        /* Floating CTA pill: visible only when the hero CTA is offscreen.
           On tablet/desktop the click re-frames the purchase module instead of a raw anchor jump. */
        (function () {
            const heroCta = document.getElementById('heroCta');
            const fab = document.getElementById('floatingCta');
            if (!heroCta || !fab) return;
            new IntersectionObserver(([entry]) => {
                fab.classList.toggle('show', !entry.isIntersecting);
            }, { threshold: 0 }).observe(heroCta);
            /* Stefan 2026-08-15: no modal - every sticky order button scrolls the
               page to the selector and its order button, centred when it fits. */
            const scrollToPurchase = (e) => {
                const purchase = document.getElementById('hero-purchase');
                if (!purchase) return;
                e.preventDefault();
                const purchaseHeight = purchase.offsetHeight;
                const viewportHeight = window.innerHeight;
                const purchaseTop = purchase.getBoundingClientRect().top + window.scrollY;
                let targetY;
                if (purchaseHeight < viewportHeight - 80) {
                    targetY = purchaseTop - (viewportHeight - purchaseHeight) / 2;
                } else {
                    targetY = purchaseTop + purchaseHeight - viewportHeight + 60;
                }
                window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
            };
            fab.addEventListener('click', scrollToPurchase);

        })();

        // Shipping pill tooltip: tap-to-toggle on touch devices
        const shipPills = document.querySelectorAll('.trust-item--ship');
        shipPills.forEach(p => {
            p.addEventListener('click', (e) => {
                if (e.target.closest('.ship-tip')) return;
                const wasOpen = p.classList.contains('open');
                shipPills.forEach(o => o.classList.remove('open'));
                if (!wasOpen) p.classList.add('open');
            });

            /* The merged single-capsule section gets ONE cascade rather than two column
               reveals, so the eye runs left to right: the five ingredient chips under the
               capsule first, then the group titles and the dosing rows in DOM order. One
               trigger on the section, opacity and transform only, and the hidden start-state
               it animates out of is declared only under html.js-anim and only under
               prefers-reduced-motion: no-preference, so it can never leave content hidden. */
            const doseItems = document.querySelectorAll('.mechanism-section .dose-in');
            if (doseItems.length) {
                ScrollTrigger.create({
                    trigger: '.mechanism-section',
                    start: 'top 72%',
                    once: true,
                    onEnter: () => {
                        gsap.to(doseItems, { y: 0, opacity: 1, duration: 0.55, stagger: 0.055, ease: 'power3.out' });
                    }
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.trust-item--ship')) shipPills.forEach(p => p.classList.remove('open'));
        });

        // Evidence-stat tooltip: tap-to-toggle on touch devices
        const evidenceStats = document.querySelectorAll('.evidence-stat');
        evidenceStats.forEach(s => {
            s.addEventListener('click', (e) => {
                if (e.target.closest('.evidence-tip')) return;
                const wasOpen = s.classList.contains('open');
                evidenceStats.forEach(o => o.classList.remove('open'));
                if (!wasOpen) s.classList.add('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.evidence-stat')) evidenceStats.forEach(s => s.classList.remove('open'));
        });

        // FAQ is native <details>/<summary>: open, close, keyboard and no-JavaScript all
        // come from the browser, so there is no accordion script here any more.

        // GSAP Animations. Runs only when the <head> probe confirmed both libraries;
        // otherwise the page is already fully visible and there is nothing to do.
        document.addEventListener('DOMContentLoaded', () => {
            if (!document.documentElement.classList.contains('js-anim')) return;

            gsap.registerPlugin(ScrollTrigger);

            gsap.from('.gsap-hero', { y: 40, opacity: 0, duration: 1, stagger: 0.15, ease: 'power3.out' });
            gsap.from('.gsap-hero-img', { x: 40, opacity: 0, duration: 1.2, ease: 'power3.out', delay: 0.3 });

            gsap.utils.toArray('.gsap-reveal').forEach(elem => {
                ScrollTrigger.create({
                    trigger: elem,
                    start: 'top 88%',
                    once: true,
                    onEnter: () => {
                        gsap.to(elem, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' });
                    }
                });
            });
        });
            }
        });

        // Last-resort guard: if GSAP is still absent once the page has fully loaded,
        // drop the flag and force every reveal block visible. Nothing can stay hidden.
        window.addEventListener('load', () => {
            if (window.gsap && window.ScrollTrigger) return;
            document.documentElement.classList.remove('js-anim');
            document.querySelectorAll('.gsap-reveal, .dose-in').forEach(el => {
                el.style.opacity = '1';
                el.style.transform = 'none';
            });
        });

        // Floating ingredient pill - tap-to-toggle for touch devices
        const heroPills = document.querySelectorAll('.product-stage .pill'); // none in V4: labels are static
        heroPills.forEach(p => {
            p.addEventListener('click', (e) => {
                if (e.target.closest('.pill-tip')) return;
                const wasOpen = p.classList.contains('open');
                heroPills.forEach(o => o.classList.remove('open'));
                if (!wasOpen) p.classList.add('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.product-stage .pill')) {
                heroPills.forEach(p => p.classList.remove('open'));
            }
        });
    
;

    /* Rolling media strip + in-page article popup (resizable / fullscreen / closable). Ported from hitpp v2. */
    (function () {
        var track = document.getElementById('rlTrack'); if (!track) return;
        /* The anchors ship as static markup, so the band is never empty with JavaScript off.
           Here they are only duplicated once, which is what makes the loop seamless. */
        var originals = [].slice.call(track.children); if (!originals.length) return;
        originals.forEach(function (a) { track.appendChild(a.cloneNode(true)); });   /* x2 for seamless loop */

        /* Marquee driven by requestAnimationFrame; pauses on hover/focus, respects reduced-motion.
           Velocity model: a touch fling sets `vel`, which then eases back to the base SPEED. */
        var mask = track.parentElement, mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
        var SPEED = 65, mx = 0, period = 0, lastTs = 0, paused = false, rafId = 0, vel = SPEED, dragging = false, justDragged = false, FLING_EASE = 2.5, inView = false;
        function measure() { var gap = parseFloat(getComputedStyle(track).columnGap) || 0; period = (track.scrollWidth + gap) / 2; }
        function frame(ts) {
            var dt = lastTs ? Math.min(48, ts - lastTs) : 16; lastTs = ts;
            if (!dragging && !paused && period > 10) { vel += (SPEED - vel) * Math.min(1, dt / 1000 * FLING_EASE); mx += vel * dt / 1000; mx = ((mx % period) + period) % period; }
            if (period > 10) track.style.transform = 'translateX(' + (-mx).toFixed(2) + 'px)';
            rafId = requestAnimationFrame(frame);
        }
        function syncMarquee() {
            if (mq.matches || !inView || document.hidden) {
                if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
                lastTs = 0;
                if (mq.matches) track.style.transform = '';
                return;
            }
            if (!rafId) { lastTs = 0; rafId = requestAnimationFrame(frame); }
        }
        function startMarquee() { measure(); syncMarquee(); }
        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; syncMarquee(); }).observe(mask);
        } else { inView = true; }
        document.addEventListener('visibilitychange', syncMarquee);
        startMarquee();
        window.addEventListener('load', measure);
        (function () {
            var imgs = track.querySelectorAll('img'), n = imgs.length; if (!n) return;
            function tick() { if (--n <= 0) measure(); }
            imgs.forEach(function (im) { im.complete ? tick() : im.addEventListener('load', tick, { once: true }); });
        })();
        var rzt, stripWidth = window.innerWidth; window.addEventListener('resize', function () { if (stripWidth === window.innerWidth) return; stripWidth = window.innerWidth; clearTimeout(rzt); rzt = setTimeout(measure, 200); }, { passive: true });
        if (!window.matchMedia || matchMedia('(hover: hover)').matches) {
            mask.addEventListener('mouseenter', function () { paused = true; });
            mask.addEventListener('mouseleave', function () { paused = false; });
        }
        mask.addEventListener('focusin', function () { paused = true; });
        mask.addEventListener('focusout', function () { paused = false; });
        /* Mobile: a finger on the strip stops it and drags it; a swipe flings it (momentum eases back to auto-scroll). */
        (function () {
            var sx, sy, smx, lx, lt, fv, committed;
            mask.addEventListener('touchstart', function (e) {
                if (!e.touches || e.touches.length !== 1 || period <= 10) return;
                var t = e.touches[0]; dragging = true; committed = false; justDragged = false;
                sx = lx = t.clientX; sy = t.clientY; smx = mx; lt = (e.timeStamp || Date.now()); fv = 0;
            }, { passive: true });
            mask.addEventListener('touchmove', function (e) {
                if (!dragging) return;
                var t = e.touches[0], x = t.clientX, y = t.clientY, dx = x - sx, dy = y - sy;
                if (!committed) {
                    if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
                    if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }   /* vertical -> let the page scroll */
                    committed = true; sx = x; smx = mx;
                }
                dx = x - sx; mx = ((smx - dx) % period + period) % period;
                var now = (e.timeStamp || Date.now()), dtt = now - lt; if (dtt > 0) fv = (x - lx) / dtt * 1000;
                lx = x; lt = now; justDragged = true;
                if (e.cancelable) e.preventDefault();
            }, { passive: false });
            function end() {
                if (!dragging) return; dragging = false;
                if (committed) { vel = Math.max(-1200, Math.min(1200, -fv)); setTimeout(function () { justDragged = false; }, 80); }
            }
            mask.addEventListener('touchend', end, { passive: true });
            mask.addEventListener('touchcancel', function () { if (dragging) { dragging = false; vel = SPEED; } }, { passive: true });
        })();
        if (mq.addEventListener) mq.addEventListener('change', startMarquee);

        var ov = document.getElementById('rlOverlay'), md = document.getElementById('rlModal'), fr = document.getElementById('rlFrame'),
            ti = document.getElementById('rlTitle'), ob = document.getElementById('rlOpen'), fbtn = document.getElementById('rlFull'),
            ftx = document.getElementById('rlFullTxt'), cb = document.getElementById('rlClose'), fb = document.getElementById('rlFallback'),
            fbN = document.getElementById('rlFbName'), fbL = document.getElementById('rlFbLogo'), fbO = document.getElementById('rlFbOpen'), last = null;
        /* Robust cross-device scroll lock: position:fixed + restore. body overflow:hidden is
           unreliable on iOS Safari (can fail to re-enable scroll on close -> page frozen). */
        var _scrollY = 0;
        function lockScroll() {
            _scrollY = window.scrollY || window.pageYOffset || 0; var b = document.body.style;
            b.position = 'fixed'; b.top = (-_scrollY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
        }
        function unlockScroll() {
            var b = document.body.style;
            b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; window.scrollTo(0, _scrollY);
        }
        function openModal(it, trig) {
            last = trig || null; ti.textContent = it.a; ob.href = it.u; fbO.href = it.u;
            if (it.e) { fb.classList.remove('show'); fr.style.display = 'block'; fr.src = it.u; }
            else { fr.style.display = 'none'; fr.removeAttribute('src'); fbN.textContent = it.a; fbL.src = (window.IPROBIO_MEDIA_SRC && window.IPROBIO_MEDIA_SRC[it.f]) || ('assets/media/' + it.f); fbL.alt = it.a; fb.classList.add('show'); }
            ov.classList.add('open'); lockScroll();
            (it.e ? cb : fbO).focus(); document.addEventListener('keydown', onKey);
        }
        function closeModal() {
            ov.classList.remove('open'); md.classList.remove('is-full'); fbtn.setAttribute('aria-pressed', 'false'); ftx.textContent = 'Celá obrazovka';
            fr.removeAttribute('src'); fb.classList.remove('show'); unlockScroll();
            document.removeEventListener('keydown', onKey); if (last && last.focus) { last.focus(); paused = false; }
        }
        function onKey(e) {
            if (e.key === 'Escape') { closeModal(); return; }
            if (e.key === 'Tab') {
                var f = [].slice.call(md.querySelectorAll('a[href],button')).filter(function (x) { return x.offsetParent !== null; });
                if (!f.length) return; var a = f[0], z = f[f.length - 1];
                if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
                else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
            }
        }
        track.addEventListener('click', function (e) {
            var a = e.target.closest && e.target.closest('.rl-logo'); if (!a) return; e.preventDefault(); if (justDragged) return;
            openModal({ a: a.getAttribute('data-outlet'), u: a.href, e: a.getAttribute('data-embed') === '1', f: a.getAttribute('data-file') }, a);
        });
        fbtn.addEventListener('click', function () { var on = md.classList.toggle('is-full'); fbtn.setAttribute('aria-pressed', on ? 'true' : 'false'); ftx.textContent = on ? 'Zmenšit' : 'Celá obrazovka'; });
        cb.addEventListener('click', closeModal);
        ov.addEventListener('click', function (e) { if (e.target === ov) closeModal(); });
    })();
    